import { Grid, Paper, Typography } from '@material-ui/core';
import gsap from 'gsap';
import { useEffect, useRef } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { aprenderColorMap, stopManagedGameAudio } from '../../../constants';
import '../../Cantar/style.css';
import Floater from './floater';
import './style.css';

const customIcons = {
  play: <img src={'/play.png'} alt="play" height={30} />,
  pause: <img src={'/pause.png'} alt="play" height={30} />,
  volume: <img src={'/sound.png'} alt="volume" height={20} />,
  volumeMute: <img src={'/mute.png'} alt="mute" height={20} />,
};

const customProgressBar = [RHAP_UI.MAIN_CONTROLS];

export const ScoreCard = ({ active, sm = 4, data, score, steps }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    const player = playerRef.current;
    const audio = player?.audio?.current;
    if (audio) {
      audio.dataset.gameAudio = 'true';
    }
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        delete audio.dataset.gameAudio;
      }
    };
  }, []);

  return (
    <Grid
      item
      container
      direction="row"
      justifyContent="space-between"
      alignItems={'center'}
      className="score-card"
      style={{ marginTop: data?.length < 6 ? '20px' : 'inherit' }}
    >
      <Grid item sm={8} style={{ marginLeft: 10 }}>
        <Typography color="primary" variant={'h4'}>
          {active?.spanishName}
        </Typography>
      </Grid>
      <Grid item sm={3}>
        <AudioPlayer
          ref={playerRef}
          autoPlay
          src={active?.audio}
          layout={'stacked'}
          showJumpControls={false}
          showSkipControls={false}
          customControlsSection={[]}
          customProgressBarSection={customProgressBar}
          customIcons={customIcons}
          onPlay={stopManagedGameAudio}
        />
      </Grid>
      <Grid item sm={5} style={{ marginLeft: 10 }}>
        <Typography color="primary" variant={'h4'} style={{ marginRight: 'auto' }}>
          Score {score ? score : 0}
        </Typography>
      </Grid>
      <Grid item sm={3}>
        <Typography color="primary" variant={'h4'} style={{ marginLeft: 'auto' }} align="center">
          {data?.length - steps}/{data?.length}
        </Typography>
      </Grid>
    </Grid>
  );
};
const acceptedColors = ['blue', 'pink', 'orange', 'green'];

export const Baloon = ({ item, handleBaloonPop, index, sm = 4 }) => {
  const balloonRef = useRef(null);
  let buttonColor = aprenderColorMap[item.buttonColor]?.toLowerCase() || 'blue';
  if (!acceptedColors.includes(buttonColor)) {
    buttonColor = 'blue';
  }
  const backgroundImage = `url("/balloons/${buttonColor}.png")`;

  // Function to handle balloon pop with GSAP animation
  const triggerPopAnimation = () => {
    if (!balloonRef.current) return;
    if (!handleBaloonPop) return;
    // Start pop animation
    gsap.to(balloonRef.current, {
      scale: 1.5,
      opacity: 0,
      duration: 0.4,
      ease: 'power1.out',
    });
    setTimeout(() => {
      handleBaloonPop(item);
    }, 400);
  };

  return (
    <Grid item sm={sm} onClick={triggerPopAnimation}>
      <Floater index={index}>
        <div id={`balloon-container`} ref={balloonRef}>
          <div className="balloon-div" style={{ backgroundImage }}>
            <img
              src={item.transparent}
              alt={item.name}
              className="balloon-image"
              style={{
                width: `${item.balloonPercentage * 100}%`,
                height: `${item.balloonPercentage * 100}%`,
                // top: `${item.balloonHeightPercentage * 100}%`,
                left: `${item.balloonWidthPercentage * 100}%`,
                transform: `translate(-${item.balloonWidthPercentage * 100}%, -${item.balloonHeightPercentage * 100}%)`,
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </Floater>
    </Grid>
  );
};

export const EmptyBaloon = () => {
  return (
    <Grid item sm={4}>
      <Floater>
        <div id={`balloon-container`}>
          <div className="empty-balloon"></div>
        </div>
      </Floater>
    </Grid>
  );
};

export const ActiveOption = ({ selected, active, old }) => {
  return (
    <Grid
      item
      sm={6}
      container
      direction={'column'}
      alignItems={'center'}
      justifyContent={selected?.spanishName === active?.spanishName ? 'space-between' : 'center'}
      component={Paper}
      style={{
        marginTop: 25,
        padding: 10,
        backgroundColor: '#FDF6AC',
      }}
    >
      {selected ? (
        selected?.spanishName === active?.spanishName ? (
          <>
            <h2
              style={{
                fontWeight: 'normal',
                backgroundImage: `linear-gradient(to left, #ec268f, #1c358f, #16B697, #16B697, #4BB1FC)`,
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent',
                textAlign: 'center',
                margin: '0px 0px',
              }}
              key={'gradually'}
            >
              ¡Muy Bien!
            </h2>
            <img
              src={!old ? selected.transparent : selected.image}
              alt={'correctImage'}
              style={{ width: 150, height: 150 }}
            />
            <Typography variant="h4" color={'primary'} align="center" style={{ padding: 5, color: selected.color }}>
              {selected.spanishName}
            </Typography>
          </>
        ) : (
          <img
            style={{
              width: 200,
              height: 'auto',
              objectFit: 'cover',
              verticalAlign: 'middle',
            }}
            src="/tryagain.gif"
            alt="tryagain"
          />
        )
      ) : (
        <h2
          style={{
            fontWeight: 'normal',
            backgroundImage: `linear-gradient(to left, #ec268f, #1c358f, #16B697, #16B697, #4BB1FC)`,
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            textAlign: 'center',
            margin: '0px 0px',
            fontSize: 35,
          }}
          key={'gradually'}
        >
          {active.spanishName}
        </h2>
      )}
    </Grid>
  );
};

export const TimeCard = ({ minutes, seconds }) => {
  return (
    <Grid item sm={6} container direction="row" justifyContent="center" alignItems={'center'}>
      <Typography color="primary" variant={'h4'}>
        {minutes}:{seconds}
      </Typography>
    </Grid>
  );
};
